// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_APIKEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTHDOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
  };
  

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let analyticsInitialized = false;

export async function initFirebaseAnalyticsIfEnabled() {
  if (analyticsInitialized || typeof window === "undefined") return;

  if (process.env.NEXT_PUBLIC_ENABLE_FIREBASE_ANALYTICS !== "true") {
    return;
  }

  const { getAnalytics, isSupported } = await import("firebase/analytics");
  const supported = await isSupported();

  if (supported) {
    getAnalytics(app);
    analyticsInitialized = true;
  }
}
